import React from 'react';

import AButton from '../../../../../manage/common/form-fields-mui/AButton';
import AFilterForm from 'components/AFilterForm/AFilterForm';

const Filters = ({
    filterForm,
    handleFilterForm,
    getList,
    EMPTY_FILTER_FORM,
    getFilterFormFields,
    dropdowns
}) => {

    const searchHandler = (filters = {}) => {
        getList({
            filters: { ...filterForm, ...filters },
            pageNo: 0
        })
    }
    

    return (
        <AFilterForm
            formFields={getFilterFormFields(filterForm,dropdowns)}
            filterForm={filterForm}
            handleFilterForm={handleFilterForm}
            applyFilterHandler={searchHandler}
            removeFilterHandler={() => searchHandler(EMPTY_FILTER_FORM)}
            btnComponent={
                <AButton
                    variant='outline'
                    outlineVariantColor={"#bfbfbf"}
                    textColor={"#000"}
                    size='xs'
                >
                    Filters
                </AButton>
            }
        />
    );
}

export default Filters;